import { IBAN_ERROR_MESSAGES } from 'ReduxLoop/constants';
import { validateIBAN } from 'ibantools';

export const capitaliseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatAndValidateIban = (iban) => {
  const formattedIban = iban.replace(/[/.\s()\-';]/g, '').toUpperCase();

  const { valid, errorCodes } = validateIBAN(formattedIban, { allowQRIBAN: false });

  if (!valid) {
    const errorCode = errorCodes[0];
    const message = IBAN_ERROR_MESSAGES[errorCode] || 'Ongeldig IBAN rekeningnummer';
    throw new Error(`${formattedIban}${message}`);
  }

  return formattedIban;
};

export const printIban = (iban) => {
  if (!iban.match(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/)) {
    return iban;
  }
  return iban.match(/.{1,4}/g).join(' ');
  // if (!iban.match(/^BE[0-9]{14}$/)) {
  //   return iban;
  // }
  // return iban.substring(0, 4) + ' ' + iban.substring(4, 8) + ' ' + iban.substring(8, 12) + ' ' + iban.substring(12);
};
